module.exports = __webpack_public_path__ + "static/introduction-f270d440cf81b2562af933566a94d739.png";